import { apiGet, apiPost, generateFormData } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

async function addParticipantToMentorshipGroup(data) {
  const request = await apiPost('add_prt', generateFormData(data), 59)
    .catch((err) => {
      console.warn('addParticipantToMentorshipGroup::add_prt err', err);
      return false;
    })
    .then(async (res) => {
      if (!res) return false;
      if (toBoolean(res.data.error)) return false;

      return true;
    });
  //

  return request;
}

async function removeParticipantfromMentorshipGroup(data) {
  const request = await apiPost('del_prt', generateFormData(data), 60)
    .catch((err) => {
      console.warn('removeParticipantfromMentorshipGroup::del_prt err', err);
      return false;
    })
    .then(async (res) => {
      if (!res) return false;
      if (toBoolean(res.data.error)) return false;

      return true;
    });
  //

  return request;
}

async function updateMentorshipGroupTitle(data) {
  const request = await apiPost('change_grp_name', generateFormData(data), 60)
    .catch((err) => {
      console.warn('updateMentorshipGroupTitle::change_grp_name err', err);
      return false;
    })
    .then(async (res) => {
      if (!res) return false;
      if (toBoolean(res.data.error)) return false;

      return true;
    });
  //

  return request;
}

async function updateMentorshipGroupDescription(data) {
  const request = await apiPost('change_grp_desc', generateFormData(data), 60)
    .catch((err) => {
      console.warn('updateMentorshipGroupDescription::change_grp_desc err', err);
      return false;
    })
    .then(async (res) => {
      if (!res) return false;
      if (toBoolean(res.data.error)) return false;

      return true;
    });
  //

  return request;
}

export default {
  async createCompanyMentorshipGroup(context, data) {
    const request = await apiPost('create_grp', generateFormData({
      ...data,
      admin: context.rootState.User.id,
    }), 59)
      .catch((err) => {
        console.warn('createCompanyMentorshipGroup::create_grp err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        return res.data.groupid || true;
      });
    //

    return request;
  },
  async updateCompanyMentorshipGroup(context, data) {
    // eslint-disable-next-line no-param-reassign
    data.admin = context.rootState.User.id;

    const currentData = await context.dispatch('getProgramMentorshipGroup', data.id);

    // compare values and run update on updated values
    const promises = [];

    if (data.title !== currentData.group_name) {
      const res = updateMentorshipGroupTitle({
        groupid: data.id,
        title: data.title,
      });

      promises.push(res);
    }

    if (data.description !== currentData.description) {
      const res = updateMentorshipGroupDescription({
        groupid: data.id,
        description: data.description,
      });

      promises.push(res);
    }

    const result = await Promise.all(promises);

    // if success on all
    if (result.every((res) => !!res)) {
      // get meeting data afresh // no need because group is not cached atm.
      // await context.dispatch('getProgramMentorshipGroup', data.id);

      return true;
    }

    return false;
  },
  async getProgramMentorshipGroups(context, [companyId, programId]) {
    const companyid = companyId || context.rootState.User.companyid;
    const programid = programId || context.rootState.User.programid;
    if (!companyid || !programid) return false;

    const request = await apiPost('company_group', generateFormData({
      companyid,
      progid: programid,
    }), 61)
      .catch((err) => {
        console.warn('getProgramMentorshipGroups::company_group err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        const mentorshipGroups = res.data.company_group || [];

        const goals = await context.dispatch('getProgramGoals', {
          companyid,
          progid: programid,
        });

        mentorshipGroups.map((group) => {
          // eslint-disable-next-line no-param-reassign
          group.goal = goals.find((goal) => Number(goal.id) === Number(group.goalid));

          return group;
        });

        return mentorshipGroups;
      });
    //

    return request;
  },
  async getProgramMentorshipGroup(context, mentorshipGroupId) {
    const request = await apiPost('groups_links', generateFormData({ groupid: mentorshipGroupId }), 59)
      .catch((err) => {
        console.warn('getProgramMentorshipGroup::group_links err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        const mentorshipGroup = (res.data.group_links || [])[0] || {};

        if (mentorshipGroup.goalid) {
          const goals = await context.dispatch('getProgramGoals', {
            companyid: mentorshipGroup.companyid,
            progid: mentorshipGroup.progid,
          });
          mentorshipGroup.goal = goals.find((goal) => Number(goal.id) === Number(mentorshipGroup.goalid));
        }

        return mentorshipGroup;
      });
    //

    return request;
  },
  // ! [DEPR] NOT USED
  async saveMentorshipGroupParticipants(context, {
    companyId, programId, groupId, participantsIds,
  }) {
    // get current participants
    /** @type {Array} */
    const currentParticipants = await context.dispatch('getMentorshipGroupParticipants', {
      groupId,
      companyId,
      programId,
    });

    participantsIds.forEach((participantId) => {
      const foundInCurrent = currentParticipants.find((participant) => Number(participant.id) === Number(participantId));

      // if already exist, skip
      if (foundInCurrent) return;

      // new, so add
      addParticipantToMentorshipGroup({
        groupid: groupId,
        userid: participantId,
        progid: programId,
      });
    });

    currentParticipants.forEach((currentParticipant) => {
      const foundInNew = participantsIds.find((participantId) => Number(participantId) === Number(currentParticipant.id));

      // if already exist, skip
      if (foundInNew) return;

      // if not exist in new list, remove
      removeParticipantfromMentorshipGroup({
        groupid: groupId,
        userid: currentParticipant.id,
        reason: '[admin]',
        progid: programId,
      });
    });
  },
  async addMentorshipGroupParticipants(context, {
    companyId, programId, groupId, participantsIds,
  }) {
    // get current participants
    /** @type {Array} */
    const currentParticipants = await context.dispatch('getMentorshipGroupParticipants', {
      groupId,
      companyId,
      programId,
    });

    participantsIds.forEach((participantId) => {
      const foundInCurrent = currentParticipants.find((participant) => Number(participant.id) === Number(participantId));

      // if already exist, skip
      if (foundInCurrent) return;

      // new, so add
      addParticipantToMentorshipGroup({
        groupid: groupId,
        userid: participantId,
        progid: programId,
      });
    });
  },
  async removeMentorshipGroupParticipants(context, {
    companyId, programId, groupId, participantsIds,
  }) {
    // get current participants
    /** @type {Array} */
    const currentParticipants = await context.dispatch('getMentorshipGroupParticipants', {
      groupId,
      companyId,
      programId,
    });

    participantsIds.forEach((participantId) => {
      const foundInCurrent = currentParticipants.find((participant) => Number(participant.id) === Number(participantId));

      // if NOT found in current, no need to remove, skip
      if (!foundInCurrent) return;

      // if not exist in new list, remove
      removeParticipantfromMentorshipGroup({
        groupid: groupId,
        userid: participantId,
        reason: '',
      });
    });
  },
  async getMentorshipGroupParticipants(context, data) {
    const companyid = data.companyId;

    const formData = generateFormData({
      companyid,
      progid: data.programId,
      groupid: data.groupId,
    });

    const request = await apiPost('company_participants', formData, 61)
      .catch((err) => {
        console.warn('getMentorshipGroupParticipants::company_participants err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        /** @type {Array} */
        const participants = res.data.company_participants || [];

        // get users' data
        const promises = [];

        // cache data first
        await Promise.allSettled([
          apiGet('gender', 5),
          apiGet('countries', 5),
          apiGet('county', 5),
          apiGet('profession', 5),
          apiGet('experience', 5),
          apiGet('availability', 5),
          apiGet('group_goals', 5),
          context.dispatch('companyRegions', companyid),
        ]);

        participants.forEach((participant) => {
          const prom = context.dispatch('getUserData', participant.userid);

          promises.push(prom);
        });

        const users = await Promise.all(promises);
        // console.log('participants::', users);

        return users;
      });
    //

    return request;
  },
  async deactivateMentorshipGroup(context, data) {
    const request = await apiPost('dev_grp', generateFormData(data), 59)
      .catch((err) => {
        console.warn('deactivateMentorshipGroup::dev_grp err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        return true;
      });
    //

    return request;
  },
  async activateMentorshipGroup(context, data) {
    const request = await apiPost('act_grp', generateFormData(data), 59)
      .catch((err) => {
        console.warn('activateMentorshipGroup::act_grp err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        return true;
      });
    //

    return request;
  },
  async endMentorshipGroup(context, groupid) {
    const request = await apiPost('end_grp', generateFormData({ groupid }), 61)
      .catch((err) => {
        console.warn('endMentorshipGroup::end_grp err', err);
        return false;
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) return false;

        return true;
      });
    //

    return request;
  },
  async getUsersInGoal(context, data) {
    const programUsers = await context.dispatch('getProgramUsers', {
      companyid: data.companyId,
      progid: data.programId,
    }, { root: true });

    if (!programUsers) return [];

    const requests = [];
    const accountsWithGoals = [];

    programUsers.forEach((programUser) => {
      // get account goals
      const accountGoalsRequest = context.dispatch('getUserGoals', [programUser.id, programUser.type, data.programId], {
        root: true,
      }).then((accountGoals) => {
        accountsWithGoals.push({
          ...programUser,
          goals: accountGoals,
        });
      });

      requests.push(accountGoalsRequest);
    });

    await Promise.all(requests);

    const usersInGoal = accountsWithGoals.filter((user) => user.goals.some((goal) => Number(goal.ementid) === Number(data.goalId)));

    return usersInGoal;
  },
  async getMentorsInGoal(context, data) {
    const usersInGoal = await context.dispatch('getUsersInGoal', data, { root: true });

    return usersInGoal.filter((user) => Number(user.type) === Number(context.rootState.User.accountTypes.mentor));
  },
  async getMenteesInGoal(context, data) {
    const usersInGoal = await context.dispatch('getUsersInGoal', data, { root: true });

    return usersInGoal.filter((user) => Number(user.type) === Number(context.rootState.User.accountTypes.mentee));
  },
};
